import React, { useState } from 'react'
import {
  PaymentElement, useStripe, useElements,
} from '@stripe/react-stripe-js'
import { v4 as uuidv4 } from 'uuid'
import getErrorMessageForRequest from '../../utils/getErrorMessageForRequest'

const MONTHLY_PLAN_ID = process.env.REACT_APP_STRIPE_MONTHLY_PLAN_ID
const YEARLY_PLAN_ID = process.env.REACT_APP_STRIPE_YEARLY_PLAN_ID

const CheckoutForm = (props) => {
  const [submitLoading, setSubmitLoading] = useState(false)
  const [idempotencyKey, setIdempotencyKey] = useState(uuidv4())

  // Initialize an instance of stripe.
  const stripe = useStripe()
  const elements = useElements()

  const handleSubmit = async (e) => {
    const {
      initiateUpgrade, email, plan, setUpgradeError,
    } = props

    e.preventDefault()
    setUpgradeError('')
    setSubmitLoading(true)

    try {
      // trigger form validation and wallet collection
      const { error: submitError } = await elements.submit()
      if (submitError) throw submitError

      // initiate the upgrade to get the client secret
      const planId = plan === 'year' ? YEARLY_PLAN_ID : MONTHLY_PLAN_ID
      let initUpgradeResult
      try {
        initUpgradeResult = await initiateUpgrade({
          plan: planId,
          idempotencyKey,
        })
      } catch (e) {
        const errorMessage = getErrorMessageForRequest({
          requestName: 'initiateUpgrade',
          response: e.response,
        })
        throw new Error(errorMessage)
      }

      // confirm the intent using the details collected by the Payment Element
      const { type, clientSecret } = initUpgradeResult
      const confirmIntent = type === 'setup' ?
        stripe.confirmSetup :
        stripe.confirmPayment
      const { error: confirmError } = await confirmIntent({
        elements,
        clientSecret,
        confirmParams: {
          /* eslint-disable camelcase */
          return_url: `${window.location.origin + window.location.pathname}#upgrade-payment`,
          payment_method_data: {
            billing_details: { email },
            allow_redisplay: 'always', // make this payment method available for future use
          },
          /* eslint-enable camelcase */
        },
      })
      if (confirmError) throw confirmError
    } catch (error) {
      setSubmitLoading(false)
      setIdempotencyKey(uuidv4()) // Reset idempotency key for next attempt
      setUpgradeError(error.message)
    }
  }

  const { upgradeError, trialUsed } = props

  return (
    <div
      translate='no'
      className={`notranslate upgrade--payment-paymentForm${submitLoading ? ' upgrade--payment-paymentForm--submitLoading' : ''}`}
    >

      <PaymentElement
        options={{
          layout: 'tabs',
          fields: {
            billingDetails: {
              name: 'auto',
              email: 'never',
              address: 'auto',
            },
          },
        }}
      />

      <button
        className='upgrade--payment-paymentForm-submit'
        disabled={!stripe || !elements}
        onClick={handleSubmit}
      >
        {!submitLoading && (
          <React.Fragment>
            {!trialUsed && (
            <React.Fragment>
              Start 14-day Free Trial

              {props.plan === 'month' && (
              <div className='upgrade--payment-paymentForm-submit-sub'>
                then pay
                {' '}
                {props.monthlyPricePerMonth}
                {' '}
                / month
              </div>
              )}

              {props.plan === 'year' && (
              <div className='upgrade--payment-paymentForm-submit-sub'>
                then pay
                {' '}
                {props.yearlyPricePerYear}
              </div>
              )}
            </React.Fragment>
            )}
            {trialUsed && (
            <React.Fragment>
              Upgrade to Pro Now

              {props.plan === 'month' && (
              <div className='upgrade--payment-paymentForm-submit-sub'>
                Pay
                {' '}
                {props.monthlyPricePerMonth}
                {' '}
                / month
              </div>
              )}

              {props.plan === 'year' && (
              <div className='upgrade--payment-paymentForm-submit-sub'>
                Pay
                {' '}
                {props.yearlyPricePerYear}
              </div>
              )}
            </React.Fragment>
            )}

          </React.Fragment>
        )}

        {submitLoading && (
          <div className='upgrade--payment-paymentForm-submitSpinnerContainer'>
            <div className='upgrade--payment-paymentForm-submitSpinner' />
          </div>
        )}

      </button>

      {upgradeError && !submitLoading && (
        <div className='upgrade--payment-paymentForm-error'>
          {upgradeError}
        </div>
      )}
    </div>
  )
}

export default CheckoutForm
